import BackupButton from "./BackupButton/BackupButton";
import ReportButton from "./ReportButton/ReportButton";

const optInUserButtons = () => (
    <>
        <ReportButton />
        <BackupButton />
    </>
);


export default optInUserButtons;
